(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-lightbox"] && !Shopify.designMode) return;
  try {
    /* Runs once per page no matter how many blocks exist. The same guard is
     used by the CGS Flexible Content section, so the two never double-bind. */
  (function () {
    if (window.__vlbInit) return;
    window.__vlbInit = true;

    var overlay = document.createElement('div');
    overlay.className = 'vlb-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="vlb-close" aria-label="Close video">&times;</button>' +
      '<div class="vlb-player"></div>';
    document.body.appendChild(overlay);

    var player = overlay.querySelector('.vlb-player');
    var closeBtn = overlay.querySelector('.vlb-close');
    var lastTrigger = null;

    function open(src, trigger) {
      lastTrigger = trigger;
      var video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      player.appendChild(video);
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      if (overlay.hidden) return;
      player.innerHTML = ''; // removes video, stops playback
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    // Open: any thumbnail on the page (works for blocks in any section)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.vlb-trigger');
      if (trigger) open(trigger.dataset.videoSrc, trigger);
    });

    closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (!player.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
